import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchProduct } from '../../actions/ProductsCreators';
import { Link } from 'react-router-dom';
import Loading from '@components/loading';
import ProductInfo from '../../containers/productSection';
import BannerSlider from '@components/Slider';
import Promotions from "@components/Promotions";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { message } from 'antd';
import { getUserName } from '@utils/session';
import ImageModal from "@components/Product/ImageModal";
import { CURATORS_ROLE } from '../../common/constants';
import { getModifyNameHistory } from '@services/productService';

class ProductDetail extends Component<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            modalVisible: false,
            modifyNameHistoryList: []
        }
    }

    componentDidMount() {
        this.loadProductInfo();
        this.loadModifyNameHistory();
    }

    loadProductInfo = () => {
        const { id } = this.props?.match?.params || '';
        this.props.fetchProduct(id);
    }

    loadModifyNameHistory = () => {
        const { id } = this.props?.match?.params;
        getModifyNameHistory(id).then(res => {
            this.setState({
                modifyNameHistoryList: res.data
            })
        }).catch(err => {
            console.log('err:', err)
        })
    }

    hasRule = (role) => {
        const roleList = JSON.parse(sessionStorage.getItem(CURATORS_ROLE) || '[]');
        return roleList.indexOf(role) >= 0
    }

    render() {
        const { modalVisible, modifyNameHistoryList } = this.state;
        const { product } = this.props;

        if (!product) {
            return <Loading spinning />;
        }
        const productLink = (
            //it's a external link, so don't use the Link from react-router-dom
            <div className="text-left">
                <a href={ product.officialURL }
                    target='_blank_'
                    className="btn btn-link"
                > Merchant's Product Page
				        </a>
            </div>
        )
        let sizeRefrence = (<div className="text-left">无尺码信息</div>);
        if (product.sizeReference && product.sizeReference.refLink && product.sizeReference.refText) {
            sizeRefrence = (
                <div className="text-left">
                    <a href={ product.sizeReference.refLink }
                        target='_blank_'
                        className="btn btn-link"
                    > { product.sizeReference.refText }
                    </a>
                </div>
            );
        }
        const images = product.images;

        const username = getUserName();
        const copingText = `https://bybieyang.com/discover/recmd?prodId=${product.id}&sn=${username || ''}&sc=SERVICE_RECMD`;
        const copyBtn = username ? (
          <CopyToClipboard text={ copingText } onCopy={ () => { message.success('copy succeed!') } }>
              <div className='btn btn-link' >复制发送给用户</div>
          </CopyToClipboard>
        ) : null;
        return (<div className='container-fluid bg-light pt-3'>
            <div className='row'>
                <div className='col-md-3'>
                    <BannerSlider images={ images } handleImageClick={() => this.setState({modalVisible: true})} />
                    { copyBtn }
                    { productLink }
                    { sizeRefrence }
                    <Promotions promotions={ product.promotions } className='mt-3' />
                    <Link className='btn btn-info mt-3' to={`/discover/similar/${product.id}`} target='_blank'>查看相似商品</Link> <br />
                    {
                        this.hasRule('SEARCH_IMAGE')
                        ?<Link className='btn btn-info mt-3' to={`/image-search/${product.id}`} target='_blank'>查看同款商品</Link>
                        : <></>
                    }
                </div>
                <ProductInfo product={product} hasRule={this.hasRule('VIEW_INVENTORY')} modifyNameHistoryList={modifyNameHistoryList} refreshProductInfo={this.loadProductInfo} />
            </div>
            <ImageModal
                visible={modalVisible}
                images={images}
                id={product.id}
                onClose={() => this.setState({modalVisible: false})}
                refreshProductInfo={this.loadProductInfo}
            />
        </div>);
    };
}

function mapStateToProps(state, ownProps) {
    return {
        product: state.products.products[ownProps?.match?.params?.id]
    };
}

export default connect(mapStateToProps, { fetchProduct })(ProductDetail);
